import { useEffect, useState } from 'react'

const MOBILE_BREAKPOINT = 768

/**
 * Trả về true khi viewport hẹp hơn breakpoint mobile (< md của Tailwind = 768px).
 * Dùng cho logic branching cần switch data source theo viewport
 * (vd: infinite scroll cho mobile, pagination cho desktop).
 *
 * SSR-safe: khởi tạo `false` để tránh hydration mismatch, effect sẽ chạy
 * client-side để sync với viewport thật.
 */
export function useIsMobile(): boolean {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const query = window.matchMedia(
            `(max-width: ${MOBILE_BREAKPOINT - 1}px)`,
        )
        const update = () => setIsMobile(query.matches)
        update()
        query.addEventListener('change', update)
        return () => query.removeEventListener('change', update)
    }, [])

    return isMobile
}
